import React from "react";
import { Modal } from "react-bootstrap";
import styled from "styled-components";
import AddLicenseForm from "./AddLicenseForm";
import { Box, HeadingStyled } from "../../../../components/styled/Elements";
import { CancelWithBg } from "../../../../components/styled/AllImages";

const AddLicenseModal = ({ show, onHide, title, action, planInfo }) => {

  return (
    <Modal size="lg" show={show} onHide={onHide} centered>
      <SelectUserModalWrapper>
        <Box className="">
          <Box className="d-flex justify-content-between align-items-center border-bottom mb-4 p-4">
            <HeadingStyled size="24px" weight="bold" color="var(--text)">
              {title}
            </HeadingStyled>
            <CancelWithBg
              className="cursor-pointer"
              style={{ height: "34px", width: "34px" }}
              onClick={onHide}
            />
          </Box>

          <Box className="mb-0 p-4 pb-2 pt-0">
            <AddLicenseForm
              title={title}
              onHide={onHide}
              addLicenseFrm="addLicenseFrm"
              action={action}
              planInfo={planInfo}
            />
          </Box>
        </Box>
      </SelectUserModalWrapper>
      {/* <Box className="modal-footer">
            
                <ButtonStyled
                    label={t("Cancel")}
                    onClick={onHide}
                    bg="var(--bgSecondary)"
                    color="var(--text2)"
                />
            
                <ButtonStyled
                    bg="var(--themeColor)"
                    label={t("Save")}
                />
            </Box> */}
    </Modal>
  );
};

export default AddLicenseModal;

const SelectUserModalWrapper = styled.div`
  .react-datepicker-wrapper {
    input {
      width: 100%;
      color: var(--text);
      font-size: 14px;
      border: none;
      padding-top: 2px;
      cursor: pointer;
      &:focus {
        border: none;
        box-shadow: none;
        outline: none;
      }
    }
  }
  .rangeIconText .mx-2 {
    margin: 0 !important;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0 0px;
    tr {
      td {
        &:first-child {
          max-width: 200px;
          width: 200px;
        }
        border-bottom: 1px solid var(--borderLight);
        padding: 8px 16px;
        color: var(--text);
        font-size: 14px;
        vertical-align: middle;
      }
      &:last-child {
        td {
          border-bottom: 0;
        }
      }
    }
    td {
      border-radius: 0 !important;
    }
  }
`;
